/*
Application Name: Practice Aid.
Application URI: https://practice-aid.com/
Description: PracticeAid is a group of professionals with collective expertise in medical and dental science, hospital administration and software development. These experts have come together to work on path-breaking solutions in Healthcare IT and deliver tangible value.
Version: 1.0.0
Author: Practice Aid.
Author URI: https://practice-aid.com/
 “M/s Totall Practice Aid Private Limited, CIN U72900MP2022PTC059139”
*/


import React from 'react'
import { useState, useEffect } from "react";
import Button from "Admin/elements/CustomButton/CustomButton.jsx";
import {
    Row,
    Col,
    Modal,
    Form,
    FormGroup,
    ControlLabel,
    FormControl,
} from "react-bootstrap";
import * as API from "Front/api/emr";

const ComplaintFilterModal = ({ showModal, handleClose, filters, symptomsCategoryList, selectedCategoryId, setSelectedCategoryId, selectedCategoryType, setSelectedCategoryType, handleSaveComplaintsFilter }) => {

    const [symptomsSubCategoryList, setSymptomsSubCategoryList] = useState([]);
    const [flag, setFlag] = useState("");
    const [rows, setRows] = useState(filters ? filters : []);
    const [clinicId, setClinicId] = useState(localStorage.getItem("clinicId"));
    const [complaintCount, setComplaintCount] = useState(false);
    const [loading, setLoading] = useState(false)
    // const [formData, setFormData] = useState(data);


    let subCategoryCheked = [];
    let flagList = "";

    const getSymptomsSubCategory = async (e, type) => {
        clearSubCategoryList();
        setSelectedCategoryType(type)
        let catId = selectedCategoryId;
        if (e) {
            catId = e.target.id;
            setSelectedCategoryId(catId)
        }

        let req = "";

        if (type === "clinic") {
            activateTab(e);
            req = {
                patientId: "",
                clinicId: clinicId,
                symptomsCategoryId: "",
            };
        } else if (type === "subcategory") {
            activateTab(e);

            req = {
                patientId: "",
                clinicId: "",
                symptomsCategoryId: catId,
            };
        }
        let resp = await API.symptomsSubCategory(req);
        if (resp.data && resp.data.status === "Success") {
            subCategoryCheked = [];
            flagList = resp.data.flag;
            if (resp.data.flag === "patientSymptomsList") {
                setSymptomsSubCategoryList(resp.data.patientSymptomsList);
                setFlag("patientSymptomsList");
                subCategoryCheked = resp.data.patientSymptomsList;
            } else if (resp.data.flag === "clinicSymptomsList") {
                setSymptomsSubCategoryList(resp.data.clinicSymptomsList);
                setFlag("clinicSymptomsList");
                subCategoryCheked = resp.data.clinicSymptomsList;
            } else if (resp.data.flag === "masterSymptomsCategoryList") {
                setSymptomsSubCategoryList(
                    resp.data.masterSymptomsSubCategoryList.data
                );
                setFlag("masterSymptomsCategoryList");
                subCategoryCheked = resp.data.masterSymptomsSubCategoryList.data;
            }
            findSubCategory();
        }
    };

    const activateTab = (e) => {
        let listCatgeory = document.getElementsByName("category");
        let ele = "";
        if (!e) {
            // if (selectedCategoryId === patientId && patientListCount === true) {
            //     ele = document.getElementById("cat" + patientId);

            //     if (ele !== null) ele.classList.add("current");
            // } else 

            if (selectedCategoryId === clinicId) {
                ele = document.getElementById("cat" + clinicId);
                console.log(ele, "ele-----")
                if (ele !== null) ele.classList.add("current");
            } else {
                ele = document.getElementById("cat" + selectedCategoryId);
                if (ele !== null) ele.classList.add("current");
            }
        } else {
            //setSelectedCategoryIdEnlarge(e.target.id);

            let subcatId = "cat" + e.target.getAttribute("id");
            for (var subCategory of listCatgeory) {
                if (subcatId === subCategory.getAttribute("id")) {
                    subCategory.classList.add("current");
                } else {
                    subCategory.classList.remove("current");
                }
            }
        }
    };



    const findSubCategory = () => {
        if (rows.length > 0) {
            rows.map((row) => {
                if (subCategoryCheked.length > 0) {
                    subCategoryCheked.map((subcat) => {
                        if (flagList === "patientSymptomsList") {
                            if (subcat.symptomsSubCategoryId === row.symptomsSubCategoryId) {
                                checkSubCategory(subcat.symptomsSubCategoryId);
                            }
                        } else {
                            if (subcat._id === row.symptomsSubCategoryId) {
                                checkSubCategory(subcat._id);
                            }
                        }
                    });
                }
            });
            setSymptomsSubCategoryList(subCategoryCheked);
        }
    };

    const checkSubCategory = (subcatId) => {
        let chkSubCategory = document.getElementsByName("subcat");
        for (var subCategory of chkSubCategory) {
            if (subcatId === subCategory.getAttribute("subcatid")) {
                subCategory.checked = true;
            }
        }
    };

    const clearSubCategoryList = () => {
        setSymptomsSubCategoryList([]);
    };

    const addOrDeleteComplaints = (e, itm) => {
        if (e.target.checked) {
            let symptomType = "master";
            let flagComplaintExist = false;
            let symptomCategoryName = itm?.clinicId ? "My Clinic" : itm?.symptomsCategoryName
            if (flag === "clinicSymptomsList") {
                symptomType = "clinic";
            } else if (flag === "patientSymptomsList") {
                symptomType = "patient";
            }

            //   formData.map((itm) => {
            //     if (itm.symptomsSubCategoryId === e.target.getAttribute("subcatid")) {
            //       itm.isDeleted = false;
            //       flagComplaintExist = true;
            //     }
            //   });

            rows.push({
                symptomsSubCategoryId: e.target.getAttribute("subcatid"),
                complaint: e.target.value,
                value: `${e.target.value}-(${symptomCategoryName})`,
                symptomsCategoryId: itm?.symptomsCategoryId
            });

            //   if (!flagComplaintExist) {
            //     formData.push({
            //       complaint: e.target.value,
            //       symptomsSubCategoryId: e.target.getAttribute("subcatid"),
            //     });
            //   }

            setRows([...rows]);
            //setFormData([...formData]);
        } else {
            deleteComplaint(e);
        }
        setComplaintCount(false);
    };

    const deleteComplaint = (e) => {
        let subCatId = e.target.getAttribute("subcatid");

        let chkbox_subact = document.getElementsByName("subcat");
        for (var chk of chkbox_subact) {
            if (chk.getAttribute("subcatid") === subCatId) {
                chk.checked = false;
            }
        }

        rows.map((itm, idx) => {
            if (itm.symptomsSubCategoryId === subCatId) {
                rows.splice(idx, 1);
                return;
            }
        });

        // formData.map((itm, idx) => {
        //   if (itm.symptomsSubCategoryId === subCatId) {
        //     itm.isDeleted = true;
        //   }
        // });

        setRows([...rows]);
        //setFormData([...formData]);
    };

    const submitHandler = (e) => {
        e.preventDefault();
        if (rows.length > 0) {
            const updatedFilters = rows.map((ele) => ({ ...ele, category: "Complaint", id: ele?.symptomsSubCategoryId }))
            handleSaveComplaintsFilter(updatedFilters)
        } else {
            setComplaintCount(true);
        }
    };



    useEffect(() => {
        const timer = setTimeout(() => {
            getSymptomsSubCategory("", selectedCategoryType)
        }, 100);

        return () => clearTimeout(timer);
    }, []);

    console.log(filters, "filerts")
    return (
        <>
            <Modal
                className="suggestion-box-modal"
                show={showModal}
                onHide={handleClose}
                dialogClassName="modal-xl"
            >
                <Modal.Header closeButton className="bg-thumbcolor">
                    <Modal.Title id="example-modal-sizes-title-lg">
                        Complaints
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="suggetion-box-enlarge">
                    <div className="system-lists">
                        <h5>Systems</h5>
                        <ul>
                            {/* <li name="category" id={"cat" + patientId}>
                                <a
                                    id={patientId}
                                    onClick={(e) => {
                                        getSymptomsSubCategory(e, "patient");
                                    }}
                                >
                                    Patient List
                                </a>
                            </li> */}
                            <li name="category" id={"cat" + clinicId}>
                                <a
                                    id={clinicId}
                                    onClick={(e) => {
                                        getSymptomsSubCategory(e, "clinic");
                                    }}
                                >
                                    My List
                                </a>
                            </li>
                            {symptomsCategoryList &&
                                symptomsCategoryList.map((item) => {
                                    return (
                                        <>
                                            <li name="category" id={"cat" + item._id}>
                                                <a
                                                    id={item._id}
                                                    onClick={(e) => {
                                                        getSymptomsSubCategory(e, "subcategory");
                                                    }}
                                                >
                                                    {item.name}
                                                </a>
                                            </li>
                                        </>
                                    );
                                })}
                        </ul>
                    </div>
                    <div className="suggestion-lists">
                        <div className="selected-complaints">
                            <div className="selected-complaint-left">
                                <h5>Complaints Selected</h5>
                                {complaintCount && (
                                    <div>
                                        <p style={{ color: "red" }}>Please select any complaint</p>
                                    </div>
                                )}
                                <ul>
                                    {rows &&
                                        rows.map((row) => {
                                            return (
                                                <li>
                                                    {row.complaint}

                                                    <span
                                                        style={{ cursor: "pointer" }}
                                                        onClick={(e) => {
                                                            deleteComplaint(e);
                                                        }}
                                                        subcatid={row.symptomsSubCategoryId}
                                                    >
                                                        ✖
                                                    </span>
                                                </li>
                                            );
                                        })}
                                </ul>
                            </div>
                            <div className="text-right">
                                <Button
                                    className="btn btn-primary btn-fill custom-btn-style "
                                    onClick={(e) => submitHandler(e)}
                                >
                                    Add
                                </Button>
                            </div>
                        </div>
                        <div className="suggestion-list">
                            {symptomsSubCategoryList &&
                                symptomsSubCategoryList.map((item) => {
                                    return (
                                        <div class="form-check form-check-emr">
                                            <input
                                                class="form-check-input"
                                                type="checkbox"
                                                value={
                                                    flag === "masterSymptomsCategoryList"
                                                        ? item.name
                                                        : item.symptomsSubCategoryName
                                                }
                                                onChange={(e) => {
                                                    addOrDeleteComplaints(e, item);
                                                }}
                                                subcatid={
                                                    flag === "patientSymptomsList"
                                                        ? item.symptomsSubCategoryId
                                                        : item._id
                                                }
                                                name="subcat"
                                                id={`subcat${flag === "patientSymptomsList"
                                                    ? item.symptomsSubCategoryId
                                                    : item._id
                                                    }`}
                                            />
                                            <label
                                                class="form-check-label"
                                                for={`subcat${flag === "patientSymptomsList"
                                                    ? item.symptomsSubCategoryId
                                                    : item._id
                                                    }`}
                                            >
                                                {flag === "masterSymptomsCategoryList"
                                                    ? item.name
                                                    : item.symptomsSubCategoryName}
                                            </label>
                                        </div>
                                    );
                                })}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ComplaintFilterModal